import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    trackFieldValue,
    trackEvent
  };

  function trackFieldValue(hash, data) {
    return axiosInstance.put("/car-details/marketing-property/" + hash, data);
  }

  function trackEvent(_ref) {
    let {
      source,
      timestamp,
      action,
      userAgent,
      referrer,
      hash,
      category = 'double-booking',
      sourceUrl,
      targetUrl
    } = _ref;
    return axiosInstance.post("/tracking", {
      type: 'cfe',
      appname: 'wkda',
      category,
      action,
      userAgent,
      referrer,
      hash,
      sourceUrl,
      targetUrl,
      source,
      timestamp
    });
  }
}